<template>
	<el-row>
		<el-row>
			<el-col :span="8">
				<div class="search-view">
					<el-input placeholder="id搜索" v-model="id" />
					<el-input placeholder="用户名搜索" v-model="userName" />
					<el-button type="primary" size="medium" style="margin-left: 10px;" @click="ss">搜索</el-button>
					<el-button type="text" size="medium" @click="daochu()">导出Excel</el-button>
				</div>
			</el-col>
		</el-row>
		<div style="height: 80px;line-height: 80px;">
			<strong>作业名称</strong>: <span>{{title}}</span>
		</div>
		<el-table :data="tableDate">
			<el-table-column label="序号" prop="id"></el-table-column>
			<el-table-column label="作业id" prop="operationId"></el-table-column>
			<el-table-column label="用户id" prop="userId"></el-table-column>
			<el-table-column label="用户昵称" prop="userName"></el-table-column>
			<el-table-column label="用户等级" prop="userLevel"></el-table-column>
			<el-table-column label="提交内容" prop="operationText"></el-table-column>
			<el-table-column label="是否批改" prop="correct">
				<template slot-scope="scope">
					<span v-if="scope.row.correct == 1" style="color: red;">未批改</span>
					<span v-if="scope.row.correct == 0">已批改</span>
				</template>
			</el-table-column>
			<el-table-column label="作业状态" prop="correct">
				<template slot-scope="scope">
					{{ scope.row.pass==0?'未批改' : scope.row.pass==1?'合格' : scope.row.pass==2 ?'不合格':'' }}
				</template>
			</el-table-column>
			<el-table-column label="提交时间" prop="createdAt"></el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<el-button type="text" @click="view(scope.row)">查看</el-button>
					<el-button type="text" @click="querenPg(scope.row,1)" v-if="scope.row.correct == 1">合格</el-button>
					<el-button type="text" @click="querenPg(scope.row,2)" v-if="scope.row.correct == 1">不合格</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div style="margin: 20px auto;width: 500px">
			<el-pagination class="pagination" background layout="total, sizes,prev, pager, next,jumper"
				:page-size="pageSize" :page-sizes="pagelist" :total="total" :current-page.sync="pageNum"
				@size-change="handleSizeChange" @current-change="handleCurrentChange" />
		</div>
		<el-dialog title="批阅" :visible.sync="centerDialogVisible" width="30%" center>
			<el-form label-position="right" label-width="90px" :model="info" ref="info">
				<el-form-item label="批改建议:" prop="suggestion" :rules="[{ 
					required: true, message: '请录入您对学员作业的建议', trigger: 'blur' }]">
					<el-input v-model="info.suggestion" type="textarea" placeholder="请录入您对学员作业的建议~500字内" show-word-limit
						maxlength="500"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="infor" @click="centerDialogVisible=false">取消</el-button>
					<el-button type="primary" @click="queren2">确认</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</el-row>
</template>

<script>
	export default {
		data() {
			return {
				pass: '',
				tableDate: [],
				id: '',
				userName: '',
				pageNum: 1,
				pageSize: 30,
				total: 0,
				pagelist: [30, 60, 100],
				title: this.$route.query.title,
				centerDialogVisible: false,
				info: {
					id: '',
					suggestion: '',
					userOperationId: ''
				}
			}
		},
		methods: {
			ss() {
				this.getInfo()
			},
			daochu() {
				this.$http.post('/api/course/clrUserOperation/exportExcel', {
					userName: this.userName,
					id: this.id,
					userId: "",
					userLevel: "",
					operationId: this.$route.query.userOperationId,
					correct: ""
				}, {
					responseType: 'blob'
				}).then(res => {
					this.$message({
						type: 'info',
						message: '正在导出表格'
					});
					const link = document.createElement('a');
					let blob = new Blob([res.data], {
						type: 'application/vnd.ms-excel'
					});
					link.style.display = 'none';
					//设置连接
					link.href = URL.createObjectURL(blob);
					link.download = '作业列表';
					document.body.appendChild(link);
					//模拟点击事件
					link.click();
					window.URL.revokeObjectURL(link.href);
					link.remove();
				})
			},
			queren2() {
				console.log(this.info);
				this.$refs.info.validate(valid => {
					if (valid) {
						this.$http.post('/api/course/clrOperationInfo/select', {
							entity: {
								userOperationId: this.info.id
							},
							page: {
								pageNum: 1,
								pageSize: 30
							}
						}).then(res => {
							console.log(res.data.data.list[0]);
							if (res.data.data.list[0]) {
								let list = res.data.data.list[0]
								console.log(list.id);
								this.$http.post('/api/course/clrOperationInfo/update', {
									id: list.id,
									suggestion: this.info.suggestion,
									pass: this.pass
								}).then(res => {
									console.log(res);
									if (res.data.status == 0) {
										this.$message.success('批阅成功')
										this.centerDialogVisible = false
										this.getInfo()
									} else {
										this.$message.error('批阅失败')
									}
								})
							}
						})

					}
				})
			},
			view(row) {
				console.log(row);

				let routeData = this.$router.resolve({
					path: './workDetails',
					query: {
						id: row.id,
						userOperationId: row.operationId,
						title: this.title,
						userId: row.userId,
						userName: row.userName,
						userLevel: row.userLevel,
						correct: row.correct,
						createdAt: row.createdAt,
						operationText: row.operationText,
						pass: row.pass
					}
				});
				window.open(routeData.href, '_blank');
				// this.$router.push({
				// 	path: './workDetails',
				// 	query: {
				// 		id: row.id,
				// 		userOperationId: row.operationId,
				// 		title: this.title,
				// 		userId: row.userId,
				// 		userName: row.userName,
				// 		userLevel: row.userLevel,
				// 		correct: row.correct,
				// 		createdAt: row.createdAt,
				// 		operationText: row.operationText,
				// 		pass:row.pass
				// 	}
				// })
			},
			querenPg(row, num) {
				console.log(row);
				this.pass = num
				this.info.id = row.id
				this.info.userOperationId = row.operationId
				if (row.correct == 1) {
					this.centerDialogVisible = true
				}
			},
			//页面的条数发生改变时
			handleSizeChange(size) {
				this.pageSize = size
				//重新请求数据
				this.getInfo()
			},
			//当前页发生改变时
			handleCurrentChange(currentPage) {
				this.pageNum = currentPage
				//重新请求数据
				this.getInfo()
			},
			getInfo() {
				this.$http.post('/api/course/clrUserOperation/select', {
					entity: {
						id: this.id,
						userId: '',
						userName: this.userName,
						userLevel: "",
						operationId: this.$route.query.userOperationId,
						correct: ""
					},
					page: {
						pageNum: this.pageNum,
						pageSize: this.pageSize
					}
				}).then(res => {
					console.log(res.data.data.list);
					res.data.data.list.forEach(i => {
						i.correct = i.correct ? 0 : 1
					})
					this.total = res.data.data.total
					this.tableDate = res.data.data.list
				})
			}
		},
		created() {
			this.getInfo()
			console.log(this.$store.state.userInfo);
		}
	}
</script>

<style scoped="scoped">

</style>
